import type { PropsWithChildren } from 'react';

export function Layout({ children }: PropsWithChildren) {
  return (
    <main className="grow overflow-auto overscroll-contain bg-gradient bg-[length:100%,auto] bg-fixed bg-no-repeat bg-level-01/full">
      {children}
    </main>
  );
}

Layout.displayName = 'Layout';
